import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, Subject, Subscription, interval, mergeMap, take, takeLast, takeWhile } from 'rxjs';
import { IPlannedPBMTasksApiResponse, IPlannedPBMTasksMap, ITasksMap, plPBMDeltaUpdates, TaskInfoResp } from '../../models/tasks-planned';
import { IUPPTasksMap, unplannedDeltaUpdates, UnplannedResponse } from '../../models/task-unplannedpickup';
import { DataRepositoryService } from '../data-repository/data-repository.service';
import { TaskInfoFormatterService } from './task-info-formatter.service';
import { ConnectionService } from '../connection/connection.service';
import { EditPBMOrder, TBTabName } from '../../models/core';
import { DataAccessService } from '../data-access/data-access.service';
import { FavouriteListAPIModel, FavBlomsModel, FavouriteListModel } from '../../models/favourite';
import { BusinessLocation } from '../../models/business-location-details';
import { environment } from '../../../../environments/environment';
import { ConnectionStatus, LocalStorage, TBDataSteamType } from '../../entity/enums';
import { CommunicationDataStream, TaskMoveCommand, PullBackTaskCommand, ShowPopup, ColorLegend } from '../../entity/utility-interfaces';
import { Navigation } from '../../entity/navigation';
import { IUnloadedTasksMap, unloadedDeltaUpdates, UnloadedResponse } from '../../models/task-unloaded';
import { Router } from '@angular/router';
import { SortMeta } from 'primeng/api';
import { ErrorMessage } from '../../entity/error.const';
import { AppConstants, IntervalDuration } from '../../entity/constants';
import { UserPreferenceEnum } from '../../../modules/setting/setting/setting.component';
import { TB_LEGENDS_COLORS } from '../../entity/color-codes';

/** Payload emitted by DataAccessService.currentSelectedRoute */
interface SelectedRoutePayload {
  isChecked: boolean;
  routeId: string;
  routeState: string;
}

/** Union of all task-bank delta/full response types */
type TabResponse = TaskInfoResp | UnplannedResponse | IPlannedPBMTasksApiResponse | UnloadedResponse;

export interface TaskBankTab {
  tab: string,
  initalApiCall: boolean,
  label: string,
  size: number
  disabled:boolean
}

@Injectable({
  providedIn: 'root'
})
export class TBCommunications {
  private dataStream: Subject<CommunicationDataStream> = new Subject();
  public dataStream$ = this.dataStream.asObservable();

  setDataStream(inputData:CommunicationDataStream){
    this.dataStream.next(inputData);
  }

}

@Injectable({
  providedIn: 'root'
})
export class TaskInfoService implements OnDestroy {
  plannedData: ITasksMap[] = [];
  unplannedData: IUPPTasksMap[] = [];
  plannedPbmData: IPlannedPBMTasksMap[] = [];
  unloadedData: IUnloadedTasksMap[] = [];
  cloudData: IUPPTasksMap[] = [];
  routeid: string = '';
  selectedRoute: [] = []
  activeIndex: TaskBankTab;
  editPBMOrderViewType = "update";
  event = false;
  favListArray = new BehaviorSubject([]);
  favData: FavouriteListAPIModel | undefined;
  preferredBLlist: FavouriteListAPIModel[] = [];
  blCollectionList = [];
  BlFavList: FavouriteListModel[] = [];
  plannedPBMTaskMap: Map<string, IPlannedPBMTasksMap> = new Map<string, IPlannedPBMTasksMap>();
  uppTaskMap: Map<string, IUPPTasksMap> = new Map<string, IUPPTasksMap>();
  selectedUnplannedFavList!: FavouriteListModel;
  selectedPlannedFavList!: FavouriteListModel;
  selectedTabName: string = TBTabName.Unplannedpickup;

  taskBankTabs:TaskBankTab[] = [
    {
      tab: TBTabName.Planned,
      initalApiCall: false,
      label: TBTabName.Planned,
      size: 0,
      disabled:true
    },
    {
      tab: TBTabName.Unplannedpickup,
      initalApiCall: false,
      label: TBTabName.Unplannedpickup,
      size: 0,
      disabled:true
    },
    {
      tab: TBTabName.Unloaded,
      initalApiCall: false,
      label: TBTabName.Unloaded,
      size: 0,
      disabled:true
    },
    {
      tab: TBTabName.PlannedPBM,
      initalApiCall: false,
      label: TBTabName.PlannedPBM,
      size: 0,
      disabled:true
    },
    {
      tab: TBTabName.PushToCloud,
      initalApiCall: false,
      label: TBTabName.PushToCloud,
      size: 0,
      disabled:true
    }
  ]
  tabSubscription: Subscription = Subscription.EMPTY;
  loading: boolean = false;
  subscriptionCollecttion: Subscription[] = [];
  private connectionStatusSubscription: Subscription = Subscription.EMPTY;
  private favListTimeoutId: ReturnType<typeof setTimeout> | null = null;
  
  kpiSelectionDisabled = false;
  colors: string[] = [
    "#e6194B", // Red
    "#4363d8", // Blue
    "#f032e6", // Magenta
    "#9A6324", // Brown
    "#808000", // Olive
    "#469990", // Teal
    "#000075", // Navy
    "#000000", // Black
    "#f58231", // Orange
    "#ffe119", // Yellow
    "#bfef45", // Lime
    "#3cb44b", // Green
    "#42d4f4", // Cyan
    "#911eb4", // Purple
    "#a9a9a9", // Grey
    "#ffd8b1", // Apricot
    "#aaffc3", // Mint
    "#dcbeff", // Lavender
    "#fabed4", // Pink
    "#800000" // Maroon
  ];
  updatePopup :ShowPopup = {
    dialogHeader: '',
    showPopup: false,
    updateTask: {} as IUPPTasksMap,
    dialogType: null
  };
  multiSortMeta:SortMeta[] = [
    { field: "route_name", order: 1 },
    { field: "stop_sequence", order: 1 },
    { field: "task_sequence", order: 1 }
  ]
  multiSortMetaUPP:SortMeta[] = [
    { field: "bl_name", order: 1 },
  ]
  multiSortMetaIndexCol:SortMeta[] = [
    { field: "index", order: 1 }
  ]
  metaKey: boolean = false;

  //color legends 
  private taskBankLegends: ColorLegend[] = [
    { label: 'Recurring', color: TB_LEGENDS_COLORS.recurring },
    { label: 'Ad-hoc', color: TB_LEGENDS_COLORS.adhoc },
    { label: 'Election', color: TB_LEGENDS_COLORS.election }
  ];
  public get gettaskBankLegends() : ColorLegend[] {
    return [...this.taskBankLegends];
  }
  

  taskMovementErrorMsg = ErrorMessage.TASKMOVEMENTRESTRICSTIONS
  isBulkProcessing = false;

  isViewChangedToPlanned : boolean= false;
  //map view and task bank task highlight communication 
  private isSelectedFromMap: Subject<{isSelectedFromMap: boolean, taskId: string, routeId?: string}> = new Subject();
  isSelectedFromMap$ = this.isSelectedFromMap.asObservable();

  private isSelectedFromPlannedTable: Subject<{isSelectedFromPlannedTable: boolean, taskId: string, routeId?: string}> = new Subject();
  isSelectedFromTaskBank$ = this.isSelectedFromPlannedTable.asObservable();

  constructor(
      private connectionService: ConnectionService
    , private taskInfoFormatterService: TaskInfoFormatterService
    , public dataRepositoryService: DataRepositoryService
    , public router: Router
    , private tbcom: TBCommunications
    , public dataAccessService : DataAccessService
    
  ) { 

    this.activeIndex = this.taskBankTabs[1]
    
    this.favListTimeoutId = setTimeout(() => {
      this.getFavList();
      this.favListTimeoutId = null;
    }, 1000);


    this.subscriptionCollecttion.push(this.dataAccessService.fitlerApplied$.subscribe(
      data => {
        if (data) {
          //All the TB tab should call the delta=false first time again after BL change
          this.taskBankTabs.forEach((tab: TaskBankTab) => {
            tab.initalApiCall = false;
            tab.size = 0;
          });
          this.activeIndex = this.taskBankTabs[1];

          //UPP tab
          this.getUnplannedPickupData(this.dataRepositoryService.selectedBusinessLocation);
          this.favListResetToDefaultBusinessLocation();

          //planned tab
          this.loadData();
          this.resetPlannedTab();

        }
      }
    ));

    this.connectionStatusSubscription = this.dataAccessService.connectionSubscription$.subscribe((connectionStatus: string) => {
      if (connectionStatus.toLowerCase() === ConnectionStatus.Offline) {
        this.tabSubscription.unsubscribe();
      }
      if (connectionStatus.toLowerCase() === ConnectionStatus.Online) {
        this.activeTabSubscription();
        this.getTaskBankDelta();
      }
    });
  }

  ngOnDestroy(): void {
    if (this.favListTimeoutId !== null) {
      clearTimeout(this.favListTimeoutId);
      this.favListTimeoutId = null;
    }
    this.tabSubscription.unsubscribe();
    this.connectionStatusSubscription.unsubscribe();
    this.subscriptionCollecttion.forEach((subscription) => subscription.unsubscribe());
  }

  loadData() {
    this.publishUpdates();
    //*******Resume old block if needed **** */
    // this.dataRepositoryService.removedRouteIds?.forEach(rmRouteIds => {
    //   this.removeDeselectedRoute(rmRouteIds);
    // });
  }
  removeDeselectedRoute(routeId: string): void {
    if (routeId) {
      this.removeRouteColor(routeId);
      [...this.dataRepositoryService.plannedTbCollection.values()].forEach(task => {
        if (task.route_id === routeId) {
          this.dataRepositoryService.plannedTbCollection.delete(task.task_id);
        }
      });

      //check if the route had task which were selected for task movement then those task should be removed from taskMovement list
      this.tbcom.setDataStream({data:routeId, type: TBDataSteamType.RemoveTask});
      this.publishUpdates();
    }
  }

  publishUpdates(){
    if(this.selectedTabName.toLowerCase()===TBTabName.Planned.toLowerCase()){
      this.setTaskBankCount(
        this.dataRepositoryService.plannedTbCollection,
        TBTabName.Planned
      );
      if (this.dataRepositoryService.plannedTbCollection.size) {
        this.dataAccessService.plannedRevised(true);
      } else {
        this.dataAccessService.plannedRevised(true);
        this.setupDataStream([], TBDataSteamType.Reset);
      }
    }
  }
  
  /**
   * Method resets the planned task tab  
   */
  resetPlannedTab(){
    // this.plannedData = []
    this.dataAccessService.plannedRevised(true);
    this.selectedTabName = TBTabName.Unplannedpickup;
  }

  /**
   * Method creates a communication object which contains data to be communicated and type of action on that data
   */
  setupDataStream(data: ITasksMap[], actionType: string) {
    if(this.selectedTabName.toLowerCase()===TBTabName.Planned.toLowerCase()){
      const dataStream: CommunicationDataStream = {
        data: data,
        type: actionType
      }
      this.tbcom.setDataStream(dataStream)
    }

  }

  /**
   * setTaskBankCount sets the count for each tab of Task Bank.
  */
  setTaskBankCount(taskCollection: Map<string, unknown>, tabName: string) {
    this.taskBankTabs.forEach((tab: TaskBankTab) => {
      if (tab.label.toLowerCase() === tabName.toLowerCase()) {
        tab.size = taskCollection.size;
      }
    });
  }

  getUnplannedPickupData(selectedBusinessLocation: string) {
    this.loading = true;
    this.getUnplannedPickup(selectedBusinessLocation, "unplanned", this.dataRepositoryService.dateOffset, this.dataRepositoryService.unplannedTbEtag).pipe(take(1))
      .subscribe({
        next: (response: UnplannedResponse) => {
          this.loading = false;
          this.taskInfoFormatterService.uppTaskAdapter(response);
          this.dataRepositoryService.unplannedTbEtag = response.etag;
          this.setTaskBankCount(this.dataRepositoryService.unplannedTbCollection, TBTabName.Unplannedpickup);
          this.taskInfoFormatterService.generateIndexing(this.dataRepositoryService.unplannedTbCollection);
          const uppData: unplannedDeltaUpdates = {isDeltaUpdate: false}
          this.dataRepositoryService.TabNameDataSetMap[TBTabName.Unplannedpickup] = this.dataRepositoryService.unplannedTbCollection; 
          this.dataAccessService.unPlannedRevised(uppData);
        },
        error: (error) => {
          this.loading = false;
          this.enableTaskBankTab();
        },
        complete: () => {
          if (this.dataRepositoryService.dateOffset === 0 && (this.tabSubscription?.closed || !this.tabSubscription)) {
            this.getTaskBankDelta();
          }
          else {
            this.loading = false;
          }
          this.enableTaskBankTab();
        }
      })
  }

  getPlannedPBMData(selectedBusinessLocation:string){
    this.loading = true;
      this.getPlannedPBM(selectedBusinessLocation, this.dataRepositoryService.dateOffset, this.dataRepositoryService.plannedPbmTbEtag).pipe(take(1))
        .subscribe({
          next: (response: IPlannedPBMTasksApiResponse) => {
            this.loading = false;
            this.taskInfoFormatterService.PBMTaskAdapter(TBTabName.PlannedPBM, response);
            this.dataRepositoryService.plannedPbmTbEtag = response.etag;
            this.setTaskBankCount(this.dataRepositoryService.plannedPbmTbCollection, TBTabName.PlannedPBM);
            this.taskInfoFormatterService.generateIndexing(this.dataRepositoryService.plannedPbmTbCollection);
            const plPBMData: plPBMDeltaUpdates = {isDeltaUpdate: false}
            this.dataAccessService.pbmRevised(plPBMData)
          },
          error: (error) => {
            this.loading = false;
            this.enableTaskBankTab();
          },
          complete: () => {
            if (this.selectedTabName.toLowerCase() === TBTabName.PlannedPBM.toLowerCase() && this.dataRepositoryService.dateOffset === 0 && (this.tabSubscription?.closed || !this.tabSubscription)) {
              this.getTaskBankDelta();
            }
            else {
              this.loading = false;
            }
            this.enableTaskBankTab();
          }
        })
  }

  /**
   * to get the previous day orders for selected BL
   * @param selectedBusinessLocation currently selected BL
   */
  
  getPreviousDayTasksData(selectedBusinessLocation: string) {
    this.loading = true;
    this.dataRepositoryService.previousDayDataCollection.clear();

    this.getPreviousDayTasks(selectedBusinessLocation, -1).pipe(take(1))
      .subscribe({
        next: (response: IPlannedPBMTasksApiResponse) => {
          this.taskInfoFormatterService.PBMTaskAdapter(TBTabName.PreviousDayOrder, response);
          this.dataAccessService.previousDayTaskUpdate(true);
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
        },
        complete: () => {
          this.loading = false;
        }
      })
  }
  /**
   * To Enable Task Bank 
   * After Receiving API response
   * for the tabs.
   */
  enableTaskBankTab() {
    let taskBankTabs = [...this.taskBankTabs]
    taskBankTabs.forEach(item =>{
      item.disabled = false;
    })
    this.taskBankTabs = taskBankTabs
  }

  getUnloadedData(selectedBusinessLocation:string){
    this.loading=true;
    this.getUnloaded(selectedBusinessLocation, this.dataRepositoryService.dateOffset, this.dataRepositoryService.unloadedTbEtag).pipe(take(1)).subscribe({
      next: (response: UnloadedResponse) => {
        this.loading = false;
        this.taskInfoFormatterService.unloadedTaskAdapter(response);
        this.dataRepositoryService.unloadedTbEtag = response.etag;
        this.setTaskBankCount(this.dataRepositoryService.unloadedTbCollection, TBTabName.Unloaded);
        this.taskInfoFormatterService.generateIndexing(this.dataRepositoryService.unloadedTbCollection);
        const unloadedData: unloadedDeltaUpdates = {isDeltaUpdate: false}
        this.dataAccessService.unloadedRevised(unloadedData);
      },
      error: (error) => {
        this.loading = false;
        this.enableTaskBankTab();
      },
      complete:()=>{
        if (this.dataRepositoryService.dateOffset === 0 && (this.tabSubscription?.closed || !this.tabSubscription)) {
          this.getTaskBankDelta();
        }
        else {
          this.loading = false;
        }
        this.enableTaskBankTab();
      }
    })
  }
  /**
   * 
   * Getting push to cloud data and calling api
   * @param selectedBusinessLocation selected business location data will fetch
   */
  getCloudData(selectedBusinessLocation:string){
    this.loading=true;
    this.getPushToCloud(selectedBusinessLocation, this.dataRepositoryService.dateOffset, this.dataRepositoryService.cloudTbEtag).pipe(take(1)).subscribe({
      next: (response: UnplannedResponse) => {
        this.loading = false;
        this.taskInfoFormatterService.cloudTaskAdapter(response);
        this.dataRepositoryService.cloudTbEtag = response.etag;
        this.setTaskBankCount(this.dataRepositoryService.cloudTbCollection, TBTabName.PushToCloud);
        this.taskInfoFormatterService.generateIndexing(this.dataRepositoryService.cloudTbCollection);
        const cloudData: unplannedDeltaUpdates = {isDeltaUpdate: false}
        this.dataAccessService.cloudRevised(cloudData);
      },
      error: (error) => {
        this.loading = false;
        this.enableTaskBankTab();
      },
      complete:()=>{
        if (this.dataRepositoryService.dateOffset === 0 && (this.tabSubscription?.closed || !this.tabSubscription)) {
          this.getTaskBankDelta();
        }
        else {
          this.loading = false;
        }
        this.enableTaskBankTab();

      }
    })
  }
  
  updateUnPlannedTaskMapModel(deltaUPPTasks: Map<string, IUPPTasksMap>, removed_tasks: string[]) {
    if (deltaUPPTasks.size) {
      deltaUPPTasks.forEach(deltaUPPTask => {
        let tbTaskObj = this.dataRepositoryService.unplannedTbCollection.get(deltaUPPTask.task_id);
        if (tbTaskObj) {
          tbTaskObj = deltaUPPTask;
          tbTaskObj.taskStateTab = TBTabName.Unplannedpickup;

          this.dataRepositoryService.unplannedTbCollection.set(deltaUPPTask.task_id, tbTaskObj);
        }
        else {
          //new entry
          this.dataRepositoryService.unplannedTbCollection.set(deltaUPPTask.task_id, deltaUPPTask);
        }
      });

    }
    if (removed_tasks?.length) {
      removed_tasks?.forEach(rmTask => {
        this.dataRepositoryService.unplannedTbCollection.delete(rmTask);
      })
    }
    const newTaskMap = new Map(this.dataRepositoryService.unplannedTbCollection.entries());
    this.dataRepositoryService.unplannedTbCollection = newTaskMap;
    this.setTaskBankCount(this.dataRepositoryService.unplannedTbCollection, TBTabName.Unplannedpickup);
    this.taskInfoFormatterService.generateIndexing(this.dataRepositoryService.unplannedTbCollection);
    const deltaUpdates: unplannedDeltaUpdates = {
      isDeltaUpdate: true,
      deltaTasks: [...deltaUPPTasks.values()],
      removedTasks: removed_tasks,
    };
    this.dataAccessService.unPlannedRevised(deltaUpdates);
  }

  updatePlannedTaskMapModel(deltaTasksMapObject: Map<string, ITasksMap>, removed_tasks: string[]) {
    if (deltaTasksMapObject.size) {
      //transform the list into groups, each group represents the route object and values within it repesents tasks
      let groups = this.taskInfoFormatterService.groupCollection([...deltaTasksMapObject.values()], 'route_id');
      //iterate through all groups
      groups?.forEach((groupRoute: { key: string; values: ITasksMap[] }) => {
        //get the task list from group (route)
        let deltaGroupTasks = groupRoute.values ?? [];
        let isRouteUnselected = !this.dataRepositoryService.selectedRouteList.find(f => f.route_id === groupRoute.key);

       //iterate through each task
        deltaGroupTasks.forEach((deltaTask: ITasksMap) => {
          if(isRouteUnselected){
            this.dataRepositoryService.plannedTbCollection.delete(deltaTask.task_id)
          }
          else{
            //update each route properties from taskMap 
            let tbTaskObj = this.dataRepositoryService.plannedTbCollection.get(deltaTask.task_id);
            //check if delta's incoming task_id is present in Task Bank collection or not
            if (tbTaskObj) {
              tbTaskObj = deltaTask;
  
              this.dataRepositoryService.plannedTbCollection.set(deltaTask.task_id, tbTaskObj);
            }
            else {
              this.dataRepositoryService.plannedTbCollection.set(deltaTask.task_id, deltaTask);
            }
          }
        });
        //sort the task for each group(route) level iteration 
        [...this.dataRepositoryService.plannedTbCollection.values()]
          .filter(f => f.route_id === groupRoute.key)
          .sort((a, b) => Number(a.stop_sequence) - Number(b.stop_sequence))

      });
    }
    let removedTaskInfo: ITasksMap[] = [];
    if (removed_tasks?.length) {
      removed_tasks?.forEach(rmTask => {
        //collect the object of removed task, before deleting from main repository collection
        const removedTask = this.dataRepositoryService.plannedTbCollection.get(rmTask);
        if (removedTask) {
          removedTaskInfo.push(removedTask);
        }
        this.dataRepositoryService.plannedTbCollection.delete(rmTask);
      });
    }
    const newTaskMap = new Map(this.dataRepositoryService.plannedTbCollection.entries());
    this.dataRepositoryService.plannedTbCollection = newTaskMap;
    this.setTaskBankCount(this.dataRepositoryService.plannedTbCollection, TBTabName.Planned);
    this.dataAccessService.plannedRevised(true, [...deltaTasksMapObject.values()], removedTaskInfo);
  }

  updatePlannedPbmTaskMapModel(deltaPlannedPBMTasks: Map<string, IPlannedPBMTasksMap>, removed_tasks:string[]){
    if (deltaPlannedPBMTasks.size) {
      deltaPlannedPBMTasks.forEach(deltaPbmTask => {
        let tbTaskObj = this.dataRepositoryService.plannedPbmTbCollection.get(deltaPbmTask.task_id);
        if (tbTaskObj) {
          tbTaskObj = deltaPbmTask;
          tbTaskObj.taskStateTab = TBTabName.PlannedPBM;

          this.dataRepositoryService.plannedPbmTbCollection.set(deltaPbmTask.task_id, tbTaskObj);
        }
        else {
          //new entry
          this.dataRepositoryService.plannedPbmTbCollection.set(deltaPbmTask.task_id, deltaPbmTask);
        }
      });

    }
    if (removed_tasks?.length) {
      removed_tasks?.forEach(rmTask => {
        this.dataRepositoryService.plannedPbmTbCollection.delete(rmTask);
      })
    }
    const newTaskMap = new Map(this.dataRepositoryService.plannedPbmTbCollection.entries());
    this.dataRepositoryService.plannedPbmTbCollection= newTaskMap;
    this.setTaskBankCount(this.dataRepositoryService.plannedPbmTbCollection, TBTabName.PlannedPBM);
    this.taskInfoFormatterService.generateIndexing(this.dataRepositoryService.plannedPbmTbCollection);
    const deltaUpdates: plPBMDeltaUpdates = {
      isDeltaUpdate: true,
      deltaTasks: [...deltaPlannedPBMTasks.values()],
      removedTasks: removed_tasks,
    };
    this.dataAccessService.pbmRevised(deltaUpdates);
  }
  updateUnloadedItemMapModel(deltaUnloadedItems: Map<string, IUnloadedTasksMap>, removed_tasks:string[]){
    if (deltaUnloadedItems.size) {
      deltaUnloadedItems.forEach(deltaUnloadedItem => {
        let tbTaskObj = this.dataRepositoryService.unloadedTbCollection.get(deltaUnloadedItem.item_id);
        if (tbTaskObj) {
          tbTaskObj = deltaUnloadedItem;

          this.dataRepositoryService.unloadedTbCollection.set(deltaUnloadedItem.item_id, tbTaskObj);
        }
        else {
          //new entry
          this.dataRepositoryService.unloadedTbCollection.set(deltaUnloadedItem.item_id, deltaUnloadedItem);
        }
      });

    }
    if (removed_tasks?.length) {
      removed_tasks?.forEach(rmTask => {
        this.dataRepositoryService.unloadedTbCollection.delete(rmTask);
      })
    }
    const newTaskMap = new Map(this.dataRepositoryService.unloadedTbCollection.entries());
    this.dataRepositoryService.unloadedTbCollection= newTaskMap;
    this.setTaskBankCount(this.dataRepositoryService.unloadedTbCollection, TBTabName.Unloaded);
    this.taskInfoFormatterService.generateIndexing(this.dataRepositoryService.unloadedTbCollection);
    const deltaUpdates: unloadedDeltaUpdates = {
      isDeltaUpdate: true,
      deltaTasks: [...deltaUnloadedItems.values()],
      removedTasks: removed_tasks,
    };
    this.dataAccessService.unloadedRevised(deltaUpdates);
  }
  /**
   * 
   * @param deltaCloudTasks mapping delta items of push to cloud
   * @param removed_tasks removing tasks from push to cloud
   */
  updateCloudTaskMapModel(deltaCloudTasks: IUPPTasksMap[] | Map<string, IUPPTasksMap>, removed_tasks: string[]) {
      let newTaskMap = new Map<string, IUPPTasksMap>();
      if (Array.isArray(deltaCloudTasks) && deltaCloudTasks.length) {
        deltaCloudTasks.forEach((cloudTask: IUPPTasksMap) => {
          // Pending backend fix: replace full-reload with true delta merge when backend supports it
              // let tbTaskObj = this.dataRepositoryService.cloudTbCollection.get(cloudTask.task_id);
              // if (!!tbTaskObj) {
              //   tbTaskObj = cloudTask;

              //   this.dataRepositoryService.cloudTbCollection.set(cloudTask.task_id, tbTaskObj);
              // }
              // else {
              //   //new entry
              //   this.dataRepositoryService.cloudTbCollection.set(cloudTask.task_id, cloudTask);
              // }
          newTaskMap.set(cloudTask.task_id, cloudTask);
        });
    } else {
      this.dataRepositoryService.cloudTbCollection.clear();
    }
    // Pending backend fix: enable removal when backend handles removed_tasks in delta
        // if (removed_tasks?.length) {
        //   removed_tasks?.forEach(rmTask => {
        //     this.dataRepositoryService.cloudTbCollection.delete(rmTask);
        //   })
        // }
        // const newTaskMap = new Map(this.dataRepositoryService.cloudTbCollection.entries());
    this.dataRepositoryService.cloudTbCollection = newTaskMap;
    this.setTaskBankCount(this.dataRepositoryService.cloudTbCollection, TBTabName.PushToCloud);
    this.taskInfoFormatterService.generateIndexing(this.dataRepositoryService.cloudTbCollection);
    const deltaUpdates: unplannedDeltaUpdates = {
      isDeltaUpdate: true,
      deltaTasks: [...deltaCloudTasks.values()],
      removedTasks: removed_tasks,
    };
    this.dataAccessService.cloudRevised(deltaUpdates);
  }
  

  /**
    * getting task bank delta call on one minute interval time based on active tab
    */  
  getTaskBankDelta() {
    this.tabSubscription = interval(IntervalDuration.TASKDELTA)
      .pipe(
        takeWhile((v) => this.dataRepositoryService.dateOffset === 0),
        mergeMap(() => this.handleActiveTab())
      )
      .subscribe({
        next: (response: TabResponse) => {
          this.processTabResponse(response);
        }
      });
  }
  /**
    * delta response processing only for selected tab
    */ 
  processTabResponse(response: TabResponse): void {
    const tabName = this.selectedTabName.toLowerCase();
   
    switch (tabName) {
      case TBTabName.Planned.toLowerCase():
        this.handlePlannedTab(response as TaskInfoResp);
        this.enableTaskBankTab();
        break;
   
      case TBTabName.Unplannedpickup.toLowerCase():
        this.handleUnplannedPickupTab(response as UnplannedResponse);
        this.enableTaskBankTab();
        break;
   
      case TBTabName.PlannedPBM.toLowerCase():
        this.handlePlannedPBMTab(response as IPlannedPBMTasksApiResponse);
        this.enableTaskBankTab();
        break;
   
      case TBTabName.Unloaded.toLowerCase():
        this.handleUnloadedTab(response as UnloadedResponse);
        this.enableTaskBankTab();
        break;

      case TBTabName.PushToCloud.toLowerCase():
        this.handleCloudTab(response as UnplannedResponse);
        this.enableTaskBankTab();
        break;
    }
  }
  /**
    * handling delta response for planned tab
    */  
  handlePlannedTab(response: TaskInfoResp) {
    this.dataRepositoryService.plannedTbEtag = response.etag;
    if (this.dataRepositoryService.selectedRouteList.length) {
      const mappedDeltaTasks = this.taskInfoFormatterService.taskDeltaAdaptArray(response);
      if (this.router.url === Navigation.MapLeaflet || this.router.url === Navigation.Landing || response?.tasks?.length || response?.removed_tasks?.length) {
        this.updatePlannedTaskMapModel(
          mappedDeltaTasks,
          response.removed_tasks
        );
      }
    } else {
      this.updatePlannedTaskMapModel(new Map<string, ITasksMap>(), []);
    }
  }
  /**
    * handling delta response for unplanned pickup tab
    */  
  handleUnplannedPickupTab(response: UnplannedResponse) {
    this.dataRepositoryService.unplannedTbEtag = response.etag;
    const mappedUppDeltaTasks = this.taskInfoFormatterService.uppTaskAdapter(response);
    if (this.router.url === Navigation.MapLeaflet  || this.router.url === Navigation.Landing || response?.tasks?.length || response?.removed_tasks?.length) {
      this.updateUnPlannedTaskMapModel(
        mappedUppDeltaTasks,
        response.removed_tasks
      );
    }
  }
  /**
    * handling delta response for planned pbm tab
    */
  handlePlannedPBMTab(response: IPlannedPBMTasksApiResponse) {
    this.dataRepositoryService.plannedPbmTbEtag = response.etag;
    const mappedPbmDeltaTasks = this.taskInfoFormatterService.PBMTaskAdapter(TBTabName.PlannedPBM, response);
    if (this.router.url === Navigation.MapLeaflet  || this.router.url === Navigation.Landing || response?.tasks?.length || response?.removed_tasks?.length) {
      this.updatePlannedPbmTaskMapModel(
        mappedPbmDeltaTasks,
        response.removed_tasks ?? []
      );
    }
  }
  /**
    * handling delta response for unloaded tab
    */
  handleUnloadedTab(response: UnloadedResponse) {
    this.dataRepositoryService.unloadedTbEtag = response.etag;
    const mappedUnloadedDeltaItems = this.taskInfoFormatterService.unloadedTaskAdapter(response);
    if (this.router.url === Navigation.MapLeaflet  || this.router.url === Navigation.Landing || response?.items?.length || response?.removed_items?.length) {
      this.updateUnloadedItemMapModel(
        mappedUnloadedDeltaItems,
        response.removed_items
      );
    }
  }
  /**
    * handling delta response for push to cloud tab
    */
  handleCloudTab(response: UnplannedResponse) {
    this.dataRepositoryService.cloudTbEtag = response.etag;
    const mappedCloudDeltaTasks = this.taskInfoFormatterService.cloudTaskAdapter(response);
    //if (response?.tasks?.length || response?.removed_tasks?.length) { // Pending backend fix: re-enable delta guard once backend sends partial updates
      this.updateCloudTaskMapModel(
        mappedCloudDeltaTasks,
        response.removed_tasks
      );
    //}
  }
  /**
    * handling active tab subscription
    */
  activeTabSubscription() {
    this.handleActiveTab().subscribe({
      next: (response: TabResponse) => {
        this.processTabResponse(response);
      }
    });
  }

  handleActiveTab(): Observable<TabResponse> {   
    if(this.router.url === Navigation.Dashboard || this.router.url === Navigation.MapLeaflet || 
      this.router.url === Navigation.Landing
    ) {
      switch (this.selectedTabName.toLowerCase()) {
        case TBTabName.Planned.toLowerCase():{
          const routeIds = this.dataRepositoryService.selectedRouteList.map(x => x.route_id);
          if (routeIds.length > 0) {
            const offset = this.dataRepositoryService.dateOffset;
            return this.getPlannedBulk(routeIds, offset, true);
          } else {
            this.enableTaskBankTab();
            return EMPTY;
          }
        }
        case TBTabName.Unplannedpickup.toLowerCase():
          return this.getUnplannedPickupDelta();
        case TBTabName.PlannedPBM.toLowerCase():
          return this.getPlannedPBMDelta();
        case TBTabName.Unloaded.toLowerCase():
          return this.getUnloadedDelta();
        case TBTabName.PushToCloud.toLowerCase():
          return this.getCloudDelta();
        default:
          return EMPTY;
      }
    }
    return EMPTY;
  }

  switchTAB(event: TaskBankTab) {
    const selectedTab = event.label;
    const apiCall = event.initalApiCall;
    this.dataAccessService.onTBTabSwitched(true);
    this.taskBankTabs.map(item => {
      item.disabled = true;
    });
    this.selectedTabName = selectedTab;
    this.activeIndex = event;
    this.dataRepositoryService.taskMovementData = {} as TaskMoveCommand;
    this.dataRepositoryService.pullBacktaskMovementData = {} as PullBackTaskCommand;
    this.dataRepositoryService.movingTasksMap.clear();
    document.documentElement.style.setProperty('--bl-route-selection-offset', `12px`);
    if (selectedTab.toLowerCase() === TBTabName.Planned.toLowerCase()) { 
      this.isViewChangedToPlanned = true;
        this.activeTabSubscription();
    } else if (selectedTab.toLowerCase() === TBTabName.Unplannedpickup.toLowerCase()) {
          this.activeTabSubscription();
          document.documentElement.style.setProperty('--bl-route-selection-offset', `130px`);
    } else if (selectedTab.toLowerCase() === TBTabName.PlannedPBM.toLowerCase()) {
      if (!apiCall) {
        event.initalApiCall = true;
        this.getPlannedPBMData(this.dataRepositoryService.selectedBusinessLocation)
        document.documentElement.style.setProperty('--bl-route-selection-offset', `130px`);
      }else{
        this.activeTabSubscription();
      }
    }
    else if (selectedTab.toLowerCase() === TBTabName.Unloaded.toLowerCase()) {
      if (!apiCall) {
        event.initalApiCall = true;
        this.getUnloadedData(this.dataRepositoryService.selectedBusinessLocation);
      }else{
        this.activeTabSubscription(); 
      }
    }
    else if (selectedTab.toLowerCase() === TBTabName.PushToCloud.toLowerCase()) {
      
      if (!apiCall) {
        event.initalApiCall = true;
        this.getCloudData(this.dataRepositoryService.selectedBusinessLocation);
      }else{
        this.activeTabSubscription(); 
      }
    }  
  }

  /*  
    This method is called when task movement is done from planned or unplanned tab.
    Tasks will be updated in planned tab according to the movement.
  */
  getPlannedDeltaOnce() {
    const routeIds = this.dataRepositoryService.selectedRouteList.map(x => x.route_id);
    const offset = this.dataRepositoryService.dateOffset;
    this.getPlannedBulk(routeIds, offset, true)
      .pipe(takeLast(1))
      .subscribe({
        next: (response: TaskInfoResp) => {
          this.handlePlannedTab(response);
        }
      });
  }
  /*  
    This method is called when task movement is done from planned pbm.
    Tasks will be updated in Unplanned pickup tab according to the movement.
  */
  getUnplannedPickupDeltaOnce() {
    this.getUnplannedPickupDelta()
      .pipe(takeLast(1))
      .subscribe({
        next: (response: UnplannedResponse) => {
          this.handleUnplannedPickupTab(response);
        }
      });
  }
  /*  
    This method is called when task movement is done from unplanned pickup.
    Tasks will be updated in plannedpbm tab according to the movement.
  */
  getPlannedPBMDeltaOnce() {
    this.getPlannedPBMDelta()
      .pipe(takeLast(1))
      .subscribe({
        next: (response: IPlannedPBMTasksApiResponse) => {
          this.handlePlannedPBMTab(response);
        }
      });
  }

  getPlanned(routeId: string, offset: number, etag: number, Event: boolean): Observable<TaskInfoResp> {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.TASKS}?routeid=${routeId}&dayoffset=${offset}&delta=false`,
      directoryType: AppConstants.DP,
      etag: etag,
      isLoader: false
    });
  }

  /**
   * Sends a bulk POST request to fetch planned tasks for multiple routes at once.
   * @param routeIds - Array of route IDs to fetch tasks for
   * @param offset - Date offset for the request
   * @param delta - Whether to fetch only delta (changed) tasks
   */
  getPlannedBulk(routeIds: string[], offset: number, delta: boolean): Observable<TaskInfoResp> {
    return this.connectionService.httpReq({
      reqType: AppConstants.POSTREQUEST,
      endUrl: AppConstants.TASKS,
      directoryType: AppConstants.DP,
      isLoader: false,
      etag: delta ? this.dataRepositoryService.plannedTbEtag : undefined,
      data: { routeIds, dateOffset: offset, delta }
    });
  }

  /**
   * Fetches and processes planned task data for multiple routes in a single bulk API call.
   * Iterates through each route in the response and adapts the tasks into the planned task bank collection.
   * Triggers a delta subscription if applicable after loading completes.
   * @param routes - Array of selected route objects (must include route_id and route_state)
   */
  getPlannedDataBulk(routes: any[]): void {
    if (!routes?.length) return;
    this.isBulkProcessing = true;
    this.loading = true;
    const routeIds = routes.map((r: any) => r.route_id);
    const offset = this.dataRepositoryService.dateOffset;
    this.getPlannedBulk(routeIds, offset, false).pipe(take(1)).subscribe({
      next: (response: TaskInfoResp) => {
        routes.forEach((route: any) => {
          this.taskInfoFormatterService.taskAdaptArray(response, {
            routeId: route.route_id,
            routeState: route.route_state,
            isChecked: true,
          });
        });
        this.dataRepositoryService.plannedTbEtag = response.etag;
        this.setTaskBankCount(this.dataRepositoryService.plannedTbCollection, TBTabName.Planned);
        this.dataAccessService.plannedRevised(false);
        this.kpiSelectionDisabled = false;
      },
      error: () => {
        this.isBulkProcessing = false;
        this.kpiSelectionDisabled = false;
        this.loading = false;
        this.enableTaskBankTab();
      },
      complete: () => {
        this.isBulkProcessing = false;
        if (this.dataRepositoryService.plannedTbCollection?.size) {
          if (this.selectedTabName.toLowerCase() === TBTabName.Planned.toLowerCase() && this.dataRepositoryService.dateOffset === 0 && (this.tabSubscription?.closed || !this.tabSubscription)) {
            this.getTaskBankDelta();
          }
          this.loading = false;
        } else {
          this.loading = false;
        }
        this.kpiSelectionDisabled = false;
        this.enableTaskBankTab();
      }
    });
  }

  /**
   * Ensures the task bank tab is set to Planned and tab switched event is triggered if needed.
   */
  /**
   * Ensures the Planned tab is active when routes are selected.
   * Switches tab and emits event to update UI.
   */
  ensurePlannedTabActive(): void {
    if (this.selectedTabName.toLowerCase() !== TBTabName.Planned.toLowerCase()) {
      this.activeIndex = this.taskBankTabs[0];
      this.dataAccessService.onTBTabSwitched(true);
    }
    this.selectedTabName = TBTabName.Planned;
  }

  getUnplannedPickup(BLID: string, status: string, offset: number, etag: number): Observable<UnplannedResponse> {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.TASKS}/unplanned?blid=${BLID}&status=${status}&daysoffset=${offset}&delta=false`,
      directoryType: AppConstants.DP,
      etag: etag,
      isLoader: false
    });
  } 

  getUnplannedPickupDelta(): Observable<UnplannedResponse> {
    let BLID = this.dataRepositoryService.selectedBusinessLocation;
    if(this.selectedPlannedFavList && this.selectedUnplannedFavList?.id !== 'default') {
      BLID = this.selectedUnplannedFavList?.blids.toString();
    }
    const status = "unplanned";
    const offset = this.dataRepositoryService.dateOffset
    const etag = this.dataRepositoryService.unplannedTbEtag
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.TASKS}/unplanned?blid=${BLID}&status=${status}&daysoffset=${offset}&delta=true`,
      directoryType: AppConstants.DP,
      etag: etag,
      isLoader: false
    });
  }
  
  getPreviousDayTasks(BLID:string,offset:number) {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.TASKS}/${AppConstants.INCOMPLETE}?blid=${BLID}&${AppConstants.DAYSOFFSET}=${offset}&delta=false`,
      directoryType: AppConstants.DP,
      isLoader: true
    });
  }

  getPlannedPBM(BLID:string,offset:number, etag: number):Observable<IPlannedPBMTasksApiResponse>{
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.TASKS}/planned?blid=${BLID}&daysoffset=${offset}&delta=false`,
      directoryType: AppConstants.DP,
      etag: etag,
      isLoader: false
    });
  }
  getPlannedPBMDelta():Observable<IPlannedPBMTasksApiResponse>{
    let BLID = this.dataRepositoryService.selectedBusinessLocation;
    if(this.selectedPlannedFavList && this.selectedPlannedFavList.id !== 'default') {
      BLID = this.selectedPlannedFavList.blids.toString();
    }
    let offset = this.dataRepositoryService.dateOffset
    let etag = this.dataRepositoryService.plannedPbmTbEtag
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.TASKS}/planned?blid=${BLID}&daysoffset=${offset}&delta=true`,
      directoryType: AppConstants.DP,
      etag: etag,
      isLoader: false
    });
  }

  getUnloaded(BLID: string, offset: number, etag: number): Observable<UnloadedResponse> {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `items/unloaded?daysoffset=${offset}&delta=false&blid=${BLID}`,
      directoryType: AppConstants.DP,
      etag: etag,
      isLoader: false
    });
  }
  /**
   * 
   * @param BLID sending selected business location id
   * @param offset sending dateoffset
   * @param etag 
   * @returns calling get api of push to cloud with delta false
   */
  getPushToCloud(BLID: string, offset: number, etag: number): Observable<UnplannedResponse> {
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.TASKS}/parked?blid=${BLID}&daysoffset=${offset}&delta=false`,
      directoryType: AppConstants.DP,
      etag: etag,
      isLoader: false
    });
  }

  getUnloadedDelta(): Observable<UnloadedResponse> {
    let BLID = this.dataRepositoryService.selectedBusinessLocation;
    let offset = this.dataRepositoryService.dateOffset;
    let etag = this.dataRepositoryService.unloadedTbEtag;
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `items/unloaded?daysoffset=${offset}&delta=true&blid=${BLID}`,
      directoryType: AppConstants.DP,
      etag: etag,
      isLoader: false
    });
  }
  /**
   * 
   * @returns calling get api of push to cloud with delta true
   */
  getCloudDelta(): Observable<UnplannedResponse> {
    let BLID = this.dataRepositoryService.selectedBusinessLocation;
    let offset = this.dataRepositoryService.dateOffset;
    let etag = 0; // this.dataRepositoryService.cloudTbEtag; Pending backend fix: swap for cloudTbEtag once backend supports partial delta for push-to-cloud
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: `${AppConstants.TASKS}/parked?daysoffset=${offset}&delta=false&blid=${BLID}`,
      directoryType: AppConstants.DP,
      etag: etag,
      isLoader: false
    });
  }

 

  /**
   * To get the User Favourite List set in preference.
   */
  getFavList() {
    const queryParams: { preferenceKey: string } = {
      preferenceKey: UserPreferenceEnum.FAVORITE_LIST
    }
    return this.connectionService.httpReq({
      reqType: AppConstants.GETREQUEST,
      endUrl: AppConstants.USER_PREFERENCES,
      directoryType: AppConstants.DP,
      data: queryParams,
      isLoader: false
    }).pipe(take(1)).subscribe(response => {
      if(response?.preferenceValue) {
          const blList = JSON.parse(response.preferenceValue);
          if(blList.length > 0) {
            this.favBLStruct(blList.filter((x: FavouriteListAPIModel) => x.fav !== 'evening'));
          } else {
            this.setDefaultOptionOnFavList();
          }
        } else {
          this.setDefaultOptionOnFavList();
        }
      });
  }

    /**
     * To format the BLID Since we are getting 
     * the BLIDs only from API response to show the Business Location Name 
     * on Hover List Name option we need to format the data
     * @param favList Fav List
     */
    favBLStruct(favList: FavouriteListAPIModel[]) {
      let tempFavList: FavouriteListModel[] = [];
      const businessLocation: BusinessLocation[] = [...(this.dataRepositoryService.businessLocationListMap).values()];
      favList?.map((fav: FavouriteListAPIModel, index: number) => {
        const blIdsWithName: FavBlomsModel[] = [];
        const blName: string[] = [];
        fav?.blids?.map((blId) => {
          const find = businessLocation.find((x) => x.business_location_id === blId);
          if (find !== undefined) {
            blIdsWithName.push({ name: find.name, id: find.business_location_id, isSelected: false });
            blName.push(find.name);
          }
        });
        tempFavList.push({ 
          name: fav.name, favBloms: blIdsWithName, 
          id: fav.id, selected: false,
          blids: fav.blids,
          blName: blName.join()});
      });
      this.setDefaultOptionOnFavList(tempFavList);
    }

    /**
     * Use to set the default option in Fav List dropdown
     * @param favList optional oarameter to use if we have list added in preferences
     */
    setDefaultOptionOnFavList(favList: FavouriteListModel[] = []) {
      const defaultList: FavouriteListModel = { name: 'Default', favBloms: [], id: 'default', selected: false, blName:'', blids:[] };
      favList.push(defaultList);
      this.favListResetToDefaultBusinessLocation();
      this.BlFavList = favList.reverse();
    }

    favListResetToDefaultBusinessLocation() {
      const defaultList: FavouriteListModel = { name: 'Default', favBloms: [], id: 'default', selected: false, blName:'', blids:[] };
      this.selectedUnplannedFavList = defaultList;
      this.selectedPlannedFavList = defaultList;
    }

    onDropdownChange($event: { value: FavouriteListModel }) {
      if($event.value) {
        if(this.selectedTabName.toLowerCase() === TBTabName.Unplannedpickup.toLowerCase()){
          //clear the task movement selection 
          this.dataAccessService.onFavBLChanged(true);
          this.dataRepositoryService.unplannedTbCollection.clear();
          if($event.value.id === 'default') {
            this.getUnplannedPickupData(this.dataRepositoryService.selectedBusinessLocation);
          } else {
            this.getUnplannedPickupData($event.value.blids.toString());
          }
        }else if (this.selectedTabName.toLowerCase() === TBTabName.PlannedPBM.toLowerCase()){
          this.dataAccessService.onFavBLChanged(true);
          this.dataRepositoryService.plannedPbmTbCollection.clear();
          if($event.value.id === 'default') {
            this.getPlannedPBMData(this.dataRepositoryService.selectedBusinessLocation);
          } else {
            this.getPlannedPBMData($event.value.blids.toString());
          }
        }
      }  
    }
    
  editPickupOrder(row: IPlannedPBMTasksMap) {
    const bl: string | null = localStorage.getItem(LocalStorage.BusinessLocation);
    const parsedBl = bl !== null ? JSON.parse(bl) : null;
    let order = new EditPBMOrder();
    order.orderNum = row.pbm_order_id ?? '';
    order.viewType = this.editPBMOrderViewType;
    order.businessLocation = {
      id: this.selectedTabName === TBTabName.Planned ? this.dataRepositoryService.selectedBusinessLocation : row.business_location_id
      , description: this.selectedTabName === TBTabName.Planned ? this.dataRepositoryService.businessLocationListMap.get(parsedBl)?.name ?? '' : row.bl_name
    };
    this.editPBMOrder(order);
  }

  editPBMOrder(orderObj: EditPBMOrder) {
    window.open(`${environment.pbmUrl}/#/fromInternalApp?data=${encodeURIComponent(JSON.stringify(orderObj))}`, `_blank`);
  }

  removeRouteColor(route_id: string){
    this.dataRepositoryService.routesColour?.delete(route_id);
  }


  /**
   * Methods for Address operations add/edit
   */

  /**
   * Method opens the popup of address update
   */
  showDialog(task:IUPPTasksMap,type: 'address' | 'manager', dialogType: 'TaskBank' | 'PreviousDayPopup'){
    this.updatePopup.updateTask = task;
    this.updatePopup.dialogType = dialogType;
    this.updatePopup.showPopup = true;
    if(type === 'address'){
      this.updatePopup.dialogHeader = 'Update Address'
    } else if (type === 'manager') {
      this.updatePopup.dialogHeader = 'Update Manager Notes'
    }
  }

  closeDialog(event: boolean){
    if(event){
      this.updatePopup.showPopup = false;
      this.updatePopup.updateTask = {} as IUPPTasksMap ;
    }

  }

  /**
   * Map view and task bank task highlighting communication subscriptions and methods 
   * 
   */

  /**
   * 
   * @param data type {isSelectedFromMap: boolean, taskId: string}
   */
  onSelectCoordinates(data: { isSelectedFromMap: boolean, taskId: string, routeId?: string }) {
    const { isSelectedFromMap, taskId, routeId } = data;
    this.isSelectedFromMap.next({
      isSelectedFromMap,
      taskId,
      routeId
    });
  }

  /**
   * 
   * @param data type {isSelectedFromPlannedTable: boolean, taskId: string}
   */
  onSelectTaskFromPlannedTable(data:{isSelectedFromPlannedTable:boolean, taskId:string, routeId?: string}) {
    const {isSelectedFromPlannedTable, taskId, routeId} = data;
    this.isSelectedFromPlannedTable.next({
      isSelectedFromPlannedTable,
      taskId,
      routeId
    });
  }

  /**
   *  Opens PBM Order Lookup in a new tab using the selected order ID
   * @param event 
   */
  lookupPBMOrder(pbm_order_id:string){
    window.open('#/lookup?pbmOrderId=' + pbm_order_id,'_blank')
  }

 /**
  * Reset the count after deselecting the route.
  */
  updatePlannedTabCount(){
    this.setTaskBankCount(this.dataRepositoryService.plannedTbCollection,TBTabName.Planned)
  }

  /**
   * this method checks the selected tab and returns its collection
   * @returns values of selected tab tb collection
   */
  getSelectedTabValues() {
    switch (this.selectedTabName.toLowerCase()) {
      case TBTabName.Unplannedpickup.toLowerCase():
        return [...this.dataRepositoryService.unplannedTbCollection.values()];
      case TBTabName.Planned.toLowerCase():
        return [...this.dataRepositoryService.plannedTbCollection.values()];
      case TBTabName.PlannedPBM.toLowerCase():
        return [...this.dataRepositoryService.plannedPbmTbCollection.values()];
      case TBTabName.Unloaded.toLowerCase():
        return [...this.dataRepositoryService.unloadedTbCollection.values()];
      case TBTabName.PushToCloud.toLowerCase():
        return [...this.dataRepositoryService.cloudTbCollection.values()];
    }
    return [];
  }
}
